<div class="custom-typeahead">
  <input class="form-control box-shadow"
    [ngClass]="{ 'has-error' : bagLocationAddress.invalid && bagLocationAddress.dirty || errorSubmitEmpty || errorNoPostcode || errorPostcodeOutsideZone }"
    id="BagLocationAddress" name="BagLocationAddress" type="text" enableError="enableError"
    #bagLocationAddress="ngModel" [(ngModel)]="locationItem" (ngModelChange)="valueChange($event)"
    (keydown)="updateSelection($event)" autocomplete="off" required appCheckEmpty>
  <label class="control-label" for="BagLocationAddress">{{ placeholder }}</label>
  <a *ngIf="!showLoader && locationItem.length > 2" class="control-btn" (click)="handleClearInput()"
    href="javascript:void(0)">
    <i class="icon">cross</i>
  </a>

  <div *ngIf="!showLoader && locationItem.length < 2" class="control-btn">
    <i class="icon">search</i>
  </div>

  <div *ngIf="items.length > 0 && !selected" class="items" (clickOutside)="close()" appClickOutside>
    <div class="items-wrapper">
      <div class="item" *ngFor="let item of items; let i = index" (click)="handleSelection(item)"
        [ngClass]="{active:isCurrent(i)}" (mouseenter)="setCurrent(i)">

        <a href="javascript:void(0)" class="title">{{ item.description }}</a>

      </div>
    </div>
  </div>
  <p class="help-block text-danger" *ngIf="bagLocationAddress.invalid && bagLocationAddress.dirty || errorSubmitEmpty">
    {{selectedLocationType === 2 ? appCopy.panelHeader['errorTextHotelRequired'+selectedLanguage] :
    appCopy.panelHeader['errorTextBusinessRequired'+selectedLanguage] }}</p>

  <p class="help-block text-danger" *ngIf="errorNoPostcode">={{selectedLocationType === 2 ?
    appCopy.panelHeader['errorTextHotelValidPostcodeRequired'+selectedLanguage] :
    appCopy.panelHeader['errorTextBusinessValidPostcodeRequired'+selectedLanguage] }}</p>

  <p class="help-block text-danger postCodeMessage" *ngIf="bagLocationAddress.valid && errorPostcodeOutsideZone" [innerHTML]="appCopy.panelHeader['errorTextPostcodeOutOfCoverageArea'+selectedLanguage]"></p>

  <ng-template [ngIf]="((bookingProduct === 'ccd' && arrivalAirlineCode === 'ZRH') || (bookingProduct === 'abc' && departureAirlineCode === 'ZRH')) && hoursDifference > 48">
    <div class="alert alert-danger" *ngIf="bookingType !== 'amend' && ((!errorNoPostcode && errorPostcodeOutsideZone) || errorHotelLocation)">
      <p [innerHTML]="appCopy.panelHeader['ZrhPostCodeOutOfService'+selectedLanguage]"></p>
    </div>
  </ng-template>

  <div class="loadingEffect" *ngIf="showLoader">
    <!-- <div class="loader loader--gray">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" />
      </svg>
    </div> -->
    <div class="mapTitle"></div>
    <div class="button"></div>
  </div>

</div>
